/* import __COLOCATED_TEMPLATE__ from './categories-topic-list.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
// Exists so plugins can use it
import TEMPLATE from "./categories-topic-list.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend());